var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualificationPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 800,
    viewBox: "0 0 376 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31012_48174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 376,
    height: 800
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 800,
    transform: "matrix(-1 0 0 1 376 0)",
    fill: "#0C29D0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31012_48174)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31012_48174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.003 521.564C262.003 513.347 268.667 506.686 276.887 506.686C285.108 506.686 291.772 513.347 291.772 521.564C291.772 529.781 285.108 536.443 276.887 536.443C268.667 536.443 262.003 529.781 262.003 521.564Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1 554.449C229.1 546.231 235.764 539.57 243.985 539.57C252.205 539.57 258.869 546.231 258.869 554.449C258.869 562.666 252.205 569.327 243.985 569.327C235.764 569.327 229.1 562.666 229.1 554.449Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.198 587.338C196.198 579.121 202.862 572.459 211.082 572.459C219.303 572.459 225.967 579.121 225.967 587.338C225.967 595.555 219.303 602.216 211.082 602.216C202.862 602.216 196.198 595.555 196.198 587.338Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.412 608.606L304.412 634.603C320.802 634.603 334.135 647.931 334.135 664.315C334.135 680.7 320.802 694.027 304.412 694.027L304.412 720.024C335.145 720.024 360.148 695.031 360.148 664.31C360.148 633.589 335.145 608.606 304.412 608.606Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.647 553.535L298.647 579.532C315.038 579.532 328.37 592.859 328.37 609.244L354.378 609.244C354.383 578.528 329.38 553.535 298.647 553.535Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.264 496.947C352.264 527.668 377.267 552.661 408 552.661L408 526.664C391.609 526.664 378.276 513.337 378.276 496.952L352.264 496.952L352.264 496.947Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.942 711.942L258.95 711.942C258.95 695.558 272.282 682.23 288.673 682.23L288.673 656.233C257.945 656.228 232.942 681.221 232.942 711.942Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.529 674.059L222.537 674.059C222.537 657.674 235.87 644.347 252.261 644.347L252.261 618.35C221.533 618.345 196.529 643.338 196.529 674.059Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.741 780.778C188.741 811.228 213.523 836 243.985 836C274.447 836 299.229 811.228 299.229 780.778C299.229 750.328 274.447 725.556 243.985 725.556C213.523 725.556 188.741 750.328 188.741 780.778ZM273.347 780.778C273.347 796.962 260.175 810.128 243.985 810.128C227.795 810.128 214.623 796.962 214.623 780.778C214.623 764.594 227.795 751.428 243.985 751.428C260.175 751.428 273.347 764.594 273.347 780.778Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 442.227C-32 472.677 -7.21767 497.449 23.2442 497.449C53.7061 497.449 78.4884 472.677 78.4884 442.227C78.4884 411.777 53.7061 387.005 23.2442 387.005C-7.21767 387.005 -32 411.772 -32 442.227ZM52.6063 442.227C52.6063 458.411 39.4343 471.577 23.2442 471.577C7.05412 471.577 -6.11793 458.411 -6.11793 442.227C-6.11793 426.043 7.05412 412.877 23.2442 412.877C39.4343 412.877 52.6063 426.043 52.6063 442.227Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.761 773.75C46.761 757.567 59.933 744.4 76.1231 744.4L76.1231 718.523C45.6612 718.523 20.8789 743.296 20.8789 773.745L46.761 773.745L46.761 773.75Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.623 482.194C214.623 466.011 227.795 452.844 243.985 452.844C260.175 452.844 273.347 466.011 273.347 482.194L299.229 482.194C299.229 451.745 274.447 426.972 243.985 426.972C213.523 426.972 188.741 451.745 188.741 482.194L214.623 482.194Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.236 608.862C103.236 592.679 116.408 579.512 132.598 579.512C148.788 579.512 161.96 592.679 161.96 608.862L187.847 608.862C187.847 578.412 163.065 553.64 132.603 553.64C102.141 553.64 77.3585 578.412 77.3585 608.862L103.236 608.862Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.279 395.428L117.271 395.428C117.271 411.812 103.939 425.14 87.5476 425.14L87.5476 451.137C118.276 451.137 143.279 426.144 143.279 395.428Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.692 433.312L153.684 433.312C153.684 449.696 140.351 463.024 123.96 463.024L123.96 489.021C154.688 489.026 179.692 464.033 179.692 433.312Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 664.32L-32 690.317C-15.609 690.317 -2.27628 703.645 -2.27628 720.029L23.7363 720.029C23.7363 689.308 -1.26691 664.32 -32 664.32Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6146 663.663L77.6146 637.665C61.2237 637.665 47.891 624.338 47.891 607.954L21.8834 607.954C21.8783 638.669 46.8816 663.663 77.6146 663.663Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.724 476.547C370.724 468.33 377.388 461.668 385.608 461.668C393.829 461.668 400.492 468.33 400.492 476.547C400.492 484.764 393.829 491.425 385.608 491.425C377.388 491.425 370.724 484.764 370.724 476.547Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.914 410.086C304.914 401.868 311.578 395.207 319.798 395.207C328.019 395.207 334.683 401.868 334.683 410.086C334.683 418.303 328.019 424.964 319.798 424.964C311.578 424.964 304.914 418.303 304.914 410.086Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.191 744.611C87.191 736.394 93.855 729.732 102.075 729.732C110.296 729.732 116.96 736.394 116.96 744.611C116.96 752.828 110.296 759.489 102.075 759.489C93.855 759.489 87.191 752.828 87.191 744.611Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 735.429L408 764.564L354.383 764.564L354.383 735.429L408 735.429Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1674 513.322L70.1674 542.456L-22.9207 542.456L-22.9207 513.322L70.1674 513.322Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6259 561.039L23.6259 590.174L-22.9206 590.174L-22.9206 561.039L23.6259 561.039Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.673 709.823L118.527 709.823L118.527 616.266L147.673 616.266L147.673 709.823Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31012_48174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.003 72.5641C262.003 64.347 268.667 57.6857 276.887 57.6857C285.108 57.6857 291.772 64.347 291.772 72.5641C291.772 80.7813 285.108 87.4426 276.887 87.4426C268.667 87.4426 262.003 80.7813 262.003 72.5641Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1 105.449C229.1 97.2314 235.764 90.5701 243.985 90.5701C252.205 90.5701 258.869 97.2314 258.869 105.449C258.869 113.666 252.205 120.327 243.985 120.327C235.764 120.327 229.1 113.666 229.1 105.449Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.198 138.338C196.198 130.121 202.862 123.459 211.082 123.459C219.303 123.459 225.967 130.121 225.967 138.338C225.967 146.555 219.303 153.216 211.082 153.216C202.862 153.216 196.198 146.555 196.198 138.338Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.412 159.606L304.412 185.603C320.802 185.603 334.135 198.931 334.135 215.315C334.135 231.7 320.802 245.027 304.412 245.027L304.412 271.024C335.145 271.024 360.148 246.031 360.148 215.31C360.148 184.589 335.145 159.606 304.412 159.606Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.647 104.535L298.647 130.532C315.038 130.532 328.37 143.859 328.37 160.244L354.378 160.244C354.383 129.528 329.38 104.535 298.647 104.535Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.264 47.9473C352.264 78.6681 377.267 103.661 408 103.661L408 77.6642C391.609 77.6642 378.276 64.3368 378.276 47.9524L352.264 47.9524L352.264 47.9473Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.942 262.942L258.95 262.942C258.95 246.558 272.282 233.23 288.673 233.23L288.673 207.233C257.945 207.228 232.942 232.221 232.942 262.942Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.529 225.059L222.537 225.059C222.537 208.674 235.87 195.347 252.261 195.347L252.261 169.35C221.533 169.345 196.529 194.338 196.529 225.059Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.741 331.778C188.741 362.228 213.523 387 243.985 387C274.447 387 299.229 362.228 299.229 331.778C299.229 301.328 274.447 276.556 243.985 276.556C213.523 276.556 188.741 301.328 188.741 331.778ZM273.347 331.778C273.347 347.962 260.175 361.128 243.985 361.128C227.795 361.128 214.623 347.962 214.623 331.778C214.623 315.594 227.795 302.428 243.985 302.428C260.175 302.428 273.347 315.594 273.347 331.778Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 -6.77298C-32 23.6767 -7.21767 48.4491 23.2442 48.4491C53.7061 48.4491 78.4884 23.6767 78.4884 -6.77298C78.4884 -37.2227 53.7061 -61.9951 23.2442 -61.9951C-7.21767 -61.9951 -32 -37.2277 -32 -6.77298ZM52.6063 -6.77298C52.6063 9.41064 39.4343 22.5774 23.2442 22.5774C7.05412 22.5774 -6.11793 9.41064 -6.11793 -6.77298C-6.11793 -22.9566 7.05412 -36.1233 23.2442 -36.1233C39.4343 -36.1233 52.6063 -22.9566 52.6063 -6.77298Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.761 324.75C46.761 308.567 59.933 295.4 76.1231 295.4L76.1231 269.523C45.6612 269.523 20.8789 294.296 20.8789 324.745L46.761 324.745L46.761 324.75Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.623 33.1942C214.623 17.0106 227.795 3.84384 243.985 3.84384C260.175 3.84384 273.347 17.0106 273.347 33.1942L299.229 33.1942C299.229 2.7445 274.447 -22.0279 243.985 -22.0279C213.523 -22.0279 188.741 2.7445 188.741 33.1942L214.623 33.1942Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.236 159.862C103.236 143.679 116.408 130.512 132.598 130.512C148.788 130.512 161.96 143.679 161.96 159.862L187.847 159.862C187.847 129.412 163.065 104.64 132.603 104.64C102.141 104.64 77.3585 129.412 77.3585 159.862L103.236 159.862Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.279 -53.5719L117.271 -53.5719C117.271 -37.1875 103.939 -23.8601 87.5476 -23.8601L87.5476 2.13708C118.276 2.13708 143.279 -22.8562 143.279 -53.5719Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.692 -15.688L153.684 -15.688C153.684 0.696388 140.351 14.0238 123.96 14.0238L123.96 40.021C154.688 40.026 179.692 15.0327 179.692 -15.688Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 215.32L-32 241.317C-15.609 241.317 -2.27628 254.645 -2.27628 271.029L23.7363 271.029C23.7363 240.308 -1.26691 215.32 -32 215.32Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6146 214.663L77.6146 188.665C61.2237 188.665 47.891 175.338 47.891 158.954L21.8834 158.954C21.8783 189.669 46.8816 214.663 77.6146 214.663Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.724 27.5469C370.724 19.3298 377.388 12.6685 385.608 12.6685C393.829 12.6685 400.492 19.3298 400.492 27.5469C400.492 35.7641 393.829 42.4254 385.608 42.4254C377.388 42.4254 370.724 35.7641 370.724 27.5469Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.191 295.611C87.191 287.394 93.855 280.732 102.075 280.732C110.296 280.732 116.96 287.394 116.96 295.611C116.96 303.828 110.296 310.489 102.075 310.489C93.855 310.489 87.191 303.828 87.191 295.611Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 286.429L408 315.564L354.383 315.564L354.383 286.429L408 286.429Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1674 64.3217L70.1674 93.4562L-22.9207 93.4562L-22.9207 64.3217L70.1674 64.3217Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6259 112.039L23.6259 141.174L-22.9206 141.174L-22.9206 112.039L23.6259 112.039Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.673 260.823L118.527 260.823L118.527 167.266L147.673 167.266L147.673 260.823Z",
    fill: "#0A1F9C",
    fillOpacity: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31012_48174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 440,
    fill: "white",
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 408 836)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31012_48174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 440,
    fill: "white",
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 408 387)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualificationPattern);
export default __webpack_public_path__ + "static/media/qualification-pattern.59846ea3ed3dd7b2fffe6ed94e64705a.svg";
export { ForwardRef as ReactComponent };